import { FavoritesState } from '../reducers/favoritesReducer'
import { IRootState } from '../reducers/rootReducer'

export const getFavorites = (state: IRootState): FavoritesState => {
	return state.favorites
}
